import React, { useEffect } from "react";
import { FiX } from "react-icons/fi";
import "./Modal.css";

const Modal = ({
  open,
  close,
  children,
  cardClassName = "",
  cardStyle = {},
}) => {
  useEffect(() => {
    if (!open) return;
    const esc = (e) => e.key === "Escape" && close();
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", esc);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", esc);
    };
  }, [open, close]);

  if (!open) return null;
  return (
    <div className="modal" role="dialog" aria-modal="true" onClick={close}>
      <div
        className={`modal-card ${cardClassName}`}
        style={cardStyle}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="modal-close" onClick={close} aria-label="Kapat">
          <FiX size={22} />
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
